import { Utils } from "../../../common/views/Utils";
import { ProductPrintModel } from "../../models/ProductModel";

export type ProductPriceProps = {
    info: ProductPrintModel;
    minPrice: string;
    maxPrice: string;
}

export default function ProductPriceView({ info, minPrice, maxPrice }: ProductPriceProps) {
    return <>
        {minPrice !== maxPrice && <>${minPrice} - ${maxPrice}</>}

        {minPrice === maxPrice && <>
            {!Utils.isNullOrEmpty(info.price) && <span>${info.price}</span>}

            {!Utils.isNullOrEmpty(info.originalPrice) && <>
                <span className="pl-10 firmed" style={{ textDecoration: "line-through" }}>
                    ${info.originalPrice}
                </span>
            </>}
        </>}
    </>
}